import * as PIXI from "pixi.js";
import TextureManager from "../../managers/TextureManager";

export default class Fire extends PIXI.Sprite {
  constructor() {
    super();
    this.addTexture();
  }
  addTexture() {
    this.texture = TextureManager.getTexture(`./images/fireworks/fire.png`);
    this.y = 50
    this.anchor.set(.5, .1);
    this.scale.set(.2);
  }
}